"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    transitionDelayVariants: ()=>transitionDelayVariants,
    cssTransitions: ()=>cssTransitions,
    transitionTimingVariants: ()=>transitionTimingVariants,
    transitionDurationVariants: ()=>transitionDurationVariants,
    transitionStaggerVariants: ()=>transitionStaggerVariants
});
const external_tv_cjs_namespaceObject = require("../tv.cjs");
const transitionTimingVariants = {
    linear: 'ease-linear',
    easeIn: 'ease-in',
    easeOut: 'ease-out',
    easeInOut: 'ease-in-out',
    initial: 'ease-initial',
    glide: 'ease-glide',
    bounce: 'ease-bounce'
};
const transitionDurationVariants = {
    snap: 'duration-snap',
    extraShort: 'duration-extra-short',
    short: 'duration-short',
    medium: 'duration-medium',
    long: 'duration-long',
    extraLong: 'duration-extra-long',
    extended: 'duration-extended',
    extraExtended: 'duration-extra-extended'
};
const transitionDelayVariants = {
    none: 'delay-none',
    short: 'delay-short',
    medium: 'delay-medium',
    long: 'delay-long'
};
const transitionStaggerVariants = {
    extraShort: 'stagger-extra-short',
    short: 'stagger-short',
    medium: 'stagger-medium',
    long: 'stagger-long',
    extraLong: 'stagger-extra-long'
};
const cssTransitions = (0, external_tv_cjs_namespaceObject.tv)({
    variants: {
        timing: transitionTimingVariants,
        duration: transitionDurationVariants,
        delay: transitionDelayVariants,
        stagger: transitionStaggerVariants
    },
    defaultVariants: {}
});
exports.cssTransitions = __webpack_exports__.cssTransitions;
exports.transitionDelayVariants = __webpack_exports__.transitionDelayVariants;
exports.transitionDurationVariants = __webpack_exports__.transitionDurationVariants;
exports.transitionStaggerVariants = __webpack_exports__.transitionStaggerVariants;
exports.transitionTimingVariants = __webpack_exports__.transitionTimingVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "cssTransitions",
    "transitionDelayVariants",
    "transitionDurationVariants",
    "transitionStaggerVariants",
    "transitionTimingVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
